import styled from '@emotion/styled';

export { ModalPrimaryButton as PaymentConfirmButton, ModalSecondaryButton as CancelButton } from '@/components/common/Modal/modalButtonStyles';

export const PaymentContainer = styled.form`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 2rem;
`;
export const Title = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
`;
export const PaymentButtonBox = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	gap: 1.2rem;
`;
export const PaymentContentBox = styled.div`
	display: flex;
	gap: 0.8rem;
	width: 100%;
`;
export const PaymentContent = styled.div`
	display: flex;
	height: 7.2rem;
	align-items: center;
	justify-content: center;
	width: 100%;
	gap: 0.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #868e96;
	background-color: #fff;
	padding: 0rem 1.2rem 0rem 0.8rem;
	border: 1px solid #dee2e6;
	cursor: pointer;
	&.active {
		border: 2px solid ${(props) => props.theme.colors.primary400};
		color: ${(props) => props.theme.colors.primary400};
	}
`;
export const GenderBox = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: repeat(3, auto);
	gap: 1.6rem;
`;
export const GenderRadio = styled.div`
	display: flex;
	gap: 0.4rem;
	align-items: center;
	input[type='radio'] {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		width: 2rem;
		height: 2rem;
		border: 1px solid #ced4da;
		border-radius: 50%;
		outline: none;
		cursor: pointer;
	}
	input[type='radio']:checked {
		background-color: #fff; // 체크 시 내부 원 색상
		border: 6px solid ${(props) => props.theme.colors.primary400};
	}
`;
export const PaymentAccountBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	background-color: #fff;
	.item {
		display: flex;
		flex-direction: column;
		gap: 0.4rem;
		.title {
			font-size: ${(props) => props.theme.fontSize.sizeLg};
			font-weight: ${(props) => props.theme.fontWeight.weightSemi};
			line-height: ${(props) => props.theme.ui.lineHeight.heading};
			letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
			color: #212529;
		}
		.content {
			font-size: ${(props) => props.theme.fontSize.sizeLg};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			line-height: ${(props) => props.theme.ui.lineHeight.heading};
			letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
			color: #212529;
		}
		.point_bold {
			color: ${(props) => props.theme.colors.primary400};
			font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		}
		.point {
			color: ${(props) => props.theme.colors.primary400};
		}
	}
`;
